export default "__VITE_ASSET__q_JYUHJZ__"